import { AccessComponentEnum, AccessLevelEnum } from 'graphql-common';
import { APP_URLS } from 'constants/urls';
import { NavItemTypeEnum } from '@lib/components/Menu/Menu';
import Icons from '@lib/components/Icons/Icons';
import { NavItemArgs } from './types';

export default function getSitesNavItem(args: NavItemArgs) {
  const { t, getUserAccessByComponent, pathname, id = '' } = args;
  const isSitesAvailable =
    getUserAccessByComponent(AccessComponentEnum.SitesManagement) !==
    AccessLevelEnum.LimitedRead;
  return {
    id: 'sites',
    title: t('sites'),
    leftIcon: Icons.sites,
    to: APP_URLS.dashboard.sites.index.getPathWithQuery(),
    type: NavItemTypeEnum.Primary,
    predictorFnVisible: () => isSitesAvailable,
    predictorFnActive: () => {
      return (
        APP_URLS.dashboard.sectors.index.isTheSameUrlAs(pathname) ||
        APP_URLS.dashboard.sectors.add.isTheSameUrlAs(pathname) ||
        APP_URLS.dashboard.sectors.edit.isTheSameUrlAs(pathname, {
          pathParts: { id },
        }) ||
        APP_URLS.dashboard.sectors.view.isTheSameUrlAs(pathname, {
          pathParts: { id },
        }) ||
        APP_URLS.dashboard.sectors.sites.isTheSameUrlAs(pathname, {
          pathParts: { id },
        }) ||
        APP_URLS.dashboard.sectors.users.isTheSameUrlAs(pathname, {
          pathParts: { id },
        })
      );
    },
    children: [
      {
        id: 'sites',
        title: t('sites'),
        to: APP_URLS.dashboard.sites.index.getPathWithQuery(),
        type: NavItemTypeEnum.PrimarySub,
        end: true,
        predictorFnVisible: () => isSitesAvailable,
        predictorFnActive: () => {
          return (
            APP_URLS.dashboard.sites.index.isTheSameUrlAs(pathname) ||
            APP_URLS.dashboard.sites.add.isTheSameUrlAs(pathname) ||
            APP_URLS.dashboard.sites.edit.isTheSameUrlAs(pathname, {
              pathParts: { id },
            }) ||
            APP_URLS.dashboard.sites.view.isTheSameUrlAs(pathname, {
              pathParts: { id },
            }) ||
            APP_URLS.dashboard.sites.areas.isTheSameUrlAs(pathname, {
              pathParts: { id },
            }) ||
            APP_URLS.dashboard.sites.users.isTheSameUrlAs(pathname, {
              pathParts: { id },
            })
          );
        },
      },
      {
        id: 'sectors',
        title: t('sectors'),
        to: APP_URLS.dashboard.sectors.index.getPathWithQuery(),
        type: NavItemTypeEnum.PrimarySub,
        end: true,
        predictorFnActive: () => {
          return (
            APP_URLS.dashboard.sectors.add.isTheSameUrlAs(pathname) ||
            APP_URLS.dashboard.sectors.edit.isTheSameUrlAs(pathname, {
              pathParts: { id },
            }) ||
            APP_URLS.dashboard.sectors.view.isTheSameUrlAs(pathname, {
              pathParts: { id },
            }) ||
            APP_URLS.dashboard.sectors.sites.isTheSameUrlAs(pathname, {
              pathParts: { id },
            }) ||
            APP_URLS.dashboard.sectors.users.isTheSameUrlAs(pathname, {
              pathParts: { id },
            })
          );
        },
      },
    ],
  };
}
